import { Draft } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

export const clearSelectedOffer = (state: Draft<IPaymentState>) => {
  state.selectedOffer = null;
  state.updatedAt = Date.now();
};
